import React from 'react';
import { useTheme } from 'styled-components';

const LittleArrowIcon = ({ fill }) => {
    const theme = useTheme();
    return (React.createElement("svg", { width: "10", height: "16", viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.279297 1.72647L1.75892 0.305664L9.7194 7.99995L1.75892 15.6942L0.279299 14.2734L6.76981 7.99995L0.279297 1.72647Z", fill: fill !== null && fill !== void 0 ? fill : theme.colors.iconColor })));
};

export { LittleArrowIcon as default };
//# sourceMappingURL=LittleArrowIcon.mjs.map
